import { ConfigInterface, keyInterface, responseInterface } from 'swr';
import { generateCRUD, useHttp } from '@Libs/http';

const postApi = generateCRUD('posts', (http, path) => ({
    async findMostViewed(_start = 0, _limit = 10) {
        const response = await http.get(`${path}/most_viewed`, {
            params: {
                _limit,
                _start,
            },
        });

        return response.data;
    },

    async findRelated(idOrSlug: string, _start = 0, _limit = 10) {
        const response = await http.get(`${path}/${idOrSlug}/related`, {
            params: {
                _limit,
                _start,
            },
        });

        return response.data;
    },

    async search(_q: string, params?: any, _start = 0, _limit = 10) {
        const response = await http.get(path, {
            params: {
                ...(_q && { _q }),
                ...params,
                _start,
                _limit,
            },
        });

        return response;
    },
}), {
    hasPagination: true,
    sort: 'createdAt:DESC',
});

export default postApi;

const FIND_POSTS_KEY = 'find_posts';
export const findPosts = (params: any, config?: ConfigInterface, key: keyInterface = FIND_POSTS_KEY): responseInterface<any, any> =>
    useHttp(key, async ({ cmsHttp }) => await postApi(cmsHttp).find(params), config);

const RELATED_KEY = 'post_related';
export const findRelated = (idOrSlug: string, start?: number, limit?: number, key: keyInterface = RELATED_KEY): responseInterface<any, any> =>
    useHttp(key, async ({ cmsHttp }) => await postApi(cmsHttp).findRelated(idOrSlug, start, limit));

const FIND_MOST_VIEWED_KEY = 'most_viewed';
export const findMostViewed = (start: number, limit: number, key: keyInterface = FIND_MOST_VIEWED_KEY): responseInterface<any, any> =>
    useHttp(key, async ({ cmsHttp }) => await postApi(cmsHttp).findMostViewed(start, limit));
